module.exports = {
	extends: [
		'/',
		'templates',
		'globals',
		'sms',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'smsStats'
	}
}